import React from "react";
import lookingGlassIcon from "../../../images/icons/icon-looking-glass.svg";
import serviceStatusIcon from "../../../images/icons/icon-service-status.svg";
import getMyIpIcon from "../../../images/icons/icon-ip.svg";

const ResourcesList = ({ resources, translations }) => (
	<ul className="w-full xl:w-2/3 flex flex-col md:flex-row justify-around gap-8 xl:gap-10 2xl:gap-28 pt-10 pb-20 lg:pt-0 md:pb-0 md:px-4 lg:px-0">
		{resources.map((resource, index) => (
			<li
				key={index}
				className="text-white group md:w-1/3 2xl:h-72 2xl:w-72 flex flex-col bg-ipxon-light-blue-gray bg-opacity-50 text-sm rounded-xl p-8 gap-4 relative justify-center overflow-hidden"
			>
				{resource?.href?.includes("service-status") ? (
					<div className="group">
						<img
							className="absolute -right-20 top-10 2xl:top-5 opacity-10 grayscale blur-sm"
							alt={resource.altText}
							draggable={false}
							src={resource.icon}
						/>
						<div className="flex justify-between opacity-20 group-hover:opacity-100 transition-opacity duration-500">
							<img
								className="h-14"
								alt={resource.altText}
								draggable={false}
								src={resource.icon}
							/>
							<p className="absolute top-5 right-5 text-center flex items-center justify-center px-[8px] py-[2px] text-xs border-2 border-ipxon-magenta rounded-md text-ipxon-magenta font-bold uppercase">
								{
									translations[
										"EmpowerServicesResourceLabelCommingSoon"
									]
								}
							</p>
						</div>
						<div className="flex flex-col pt-5 gap-2 opacity-20 group-hover:opacity-100 transition-opacity duration-500">
							<h4 className="font-bold uppercase text-sm">
								{resource.title}
							</h4>
							<p className="opacity-50 text-sm">
								{resource.text}
							</p>
						</div>
					</div>
				) : (
					<a
						className="hover:cursor-pointer"
						rel="noreferrer"
						target="_blank"
						onClick={(e) => {
							e.preventDefault();
							const url = resource.href.replace('<ENV_ROLE>', process.env.NODE_ENV);
							window.open(url, '_blank');
						}}
					>
						<div>
							<img
								className="absolute -right-20 top-10 2xl:top-5 opacity-10 grayscale group-hover:scale-150 transition-all duration-500 blur-sm group-hover:blur-0"
								alt={resource.altText}
								draggable={false}
								src={resource.icon}
							/>
							<div className="flex justify-between">
								<img
									className="h-14"
									alt={resource.altText}
									draggable={false}
									src={resource.icon}
								/>
								<p className="absolute top-5 right-5 text-center flex items-center justify-center px-[8px] py-[2px] text-xs border-2 border-ipxon-magenta rounded-md text-ipxon-magenta font-bold uppercase">
									{
										translations[
											"EmpowerServicesResourceLabel"
										]
									}
								</p>
							</div>
							<div className="flex flex-col pt-5 gap-2">
								<h4 className="font-bold uppercase group-hover:text-ipxon-magenta transition-all duration-200 text-sm">
									{resource.title}
								</h4>
								<p className="opacity-50 text-sm">
									{resource.text}
								</p>
							</div>
						</div>
					</a>
				)}
			</li>
		))}
	</ul>
);

const EmpowerServicesSection = ({ translations }) => {
	const resources = [
		{
			icon: lookingGlassIcon,
			title: translations["EmpowerServicesResourceOneTitle"],
			text: translations["EmpowerServicesResourceOneText"],
			href: process.env.GATSBY_LOOKING_GLASS_URL,
		},
		{
			icon: serviceStatusIcon,
			title: translations["EmpowerServicesResourceTwoTitle"],
			text: translations["EmpowerServicesResourceTwoText"],
			href: "service-status",
		},
		{
			icon: getMyIpIcon,
			title: translations["EmpowerServicesResourceThreeTitle"],
			text: translations["EmpowerServicesResourceThreeText"],
			href: process.env.GATSBY_GET_MY_IP_URL,
		},
	];
	return (
		<div className="flex flex-col lg:flex-row items-start xl:items-center  justify-between container mx-auto">
			<div className={`flex flex-col gap-1`}>
				<h4 className={`text-lg text-ipxon-magenta`}>
					{translations["EmpowerServicesSmallTitle"]}
				</h4>
				<h3 className="text-3xl md:text-4xl font-bold">
					{translations["EmpowerServicesTitleThree"]}
				</h3>
				<p>{translations["EmpowerServicesTitleIntro"]}</p>
			</div>
			<ResourcesList resources={resources} translations={translations} />
		</div>
	);
};

export default EmpowerServicesSection;
